import { render, staticRenderFns } from "./ToggleRadioCardParts.vue?vue&type=template&id=1d8bad46&scoped=true"
import script from "./ToggleRadioCardParts.vue?vue&type=script&lang=ts"
export * from "./ToggleRadioCardParts.vue?vue&type=script&lang=ts"
import style0 from "./ToggleRadioCardParts.vue?vue&type=style&index=0&id=1d8bad46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8bad46",
  null
  
)

export default component.exports